const ArchiveMusicVideos2024Static = () => {
    return (
      <>
        <div class="music-video">

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/UARzWic5SnY" title="u$ v3" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lugosi</strong><br/>
            u$ v3
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/QBVe2zzlhRc" title="sixtyminutes" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>rileylol</strong><br/>
            sixtyminutes
          </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/2-770OlCAYc" title="+++rice" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lugosi</strong><br/>
            +++rice (prod. bygadriel)
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/lT7F5eKwxlU" title="portland" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>rileylol</strong><br/>
            portland
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/Bs84gP1d888" title="Katy" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>ANJU Online!</strong><br/>
            Katy
          </p>
            
        </div>
      </>
    );
  };
  export default ArchiveMusicVideos2024Static;